{
    "navigation": {
        "energySupply": "Energy Supply",
        "generation": "Generation",
        "supply": "Supply",
        "availability": "Availability",
        "financial": "Financial",
        "demand": "Demand",
        "profile": "Profile",
        "settings": "Settings",
        "adminDashboard": "Admin Dashboard",
        "portfolio": "Portfolio"
    },
    "dashboard": {
        "tabPanel": {
            "tabTitle": {
                "portfolios": "Portfolios",
                "sites": "Sites",
                "assets": "Assets",
                "dataPoints": "Data Points",
                "graphCollections": "Graph Collections",
                "userPermissions": "User Permissions"
            },
            "table": {
                "name": "Name"
            }
        },
        "deleteConfirmation": {
            "deleteActionConfirmMessage": "Please confirm your action: Delete '{{data}}'."
        },
        "portfolio": {
            "deletePortfolioBtn": "Delete Portfolio"
        },
        "site": {
            "deleteSiteBtn": "Delete Site",
            "error": {
                "atLeastOneSiteRequired": "At least one site must be entered."
            },
            "info": {
                "multipleSiteInputInfo": "You can add multiple sites by entering one name at a time and pressing Enter. At least one site must be entered."
            }
        },
        "asset": {
            "deleteAssetBtn": "Delete Asset"
        },
        "dataSeries": {
            "deleteDataSeriesBtn": "Delete Data Point"
        },
        "userPermissions": {
            "delete": "Delete User Permissions"
        },
        "createPortfolio": "Create Portfolio",
        "createSite": "Create Site",
        "createAsset": "Create Asset",
        "createDataPoint": "Create Data Point",
        "createGraphCollection": "Create Graph Collection",
        "createUserPermission": "Create User Permission"
    },
    "login": {
        "login": "Login",
        "loginAuth0": "Login",
        "loginText": "Please log in using your assigned account (KID or email)",
        "signUp": "Sign Up",
        "signUpText": "Don't have an account? "
    },
    "profile": {
        "tenant": "Tenant",
        "role": "Role",
        "personal data": "Personal Data",
        "language": "Language",
        "logout": "Logout "
    },
    "button": {
        "download": "Download",
        "uploadDemand": "Upload Demand",
        "enterDowntime": "Enter Downtime",
        "reset": "Reset",
        "cancel": "Cancel",
        "save": "Save",
        "update": "Update",
        "add": "Add",
        "addTimeSlot": "Add a new time slot"
    },
    "graphCollection": {
        "caption": {
            "graphExplanation": "Dashed lines: Predicted Values, Solid lines: Actual values"
        }
    },
    "dialogScreen": {
        "asset": "Asset",
        "form": {
            "title": "Add a new time slot",
            "editTitle": "Updating Asset",
            "updateTitle": "Editing Asset",
            "input": {
                "label": {
                    "type": "Type",
                    "selectAsset": "Select an asset",
                    "startDate": "Start Date",
                    "startTime": "Start Time",
                    "endDate": "End Date",
                    "endTime": "End Time",
                    "minRestriction": "Min. Restriction",
                    "maxRestriction": "Max. Restriction"
                }
            },
            "assetSelectLabel": "Select an asset",
            "typeLabel": "Type"
        }
    },
    "heatMap": {
        "time": "Time",
        "total": "Total"
    },
    "sitePortfolio": {
        "site": "Site",
        "portfolio": "Portfolio"
    },
    "error": {
        "An unexpected error occurred. Please try again.": "An unexpected error occurred. Please try again.",
        "409": "Something went wrong, please reload the page and try again.",
        "400": "The request was invalid. Please check your input and try again."
    },
    "Power Generation": "Power Generation",
    "Heat Generation": "Heat Generation",
    "Heat Consumption": "Heat Consumption",
    "Cooling Generation": "Cooling Generation",
    "Gas": "Gas",
    "Thermal Storage": "Thermal Storage",
    "Heat Supply": "Heat Supply",
    "Power Supply": "Power Supply",
    "Planning": "Planning",
    "Power Cost": "Power Cost",
    "Value Add": "Value Add",
    "Energy Cost": "Energy Cost",
    "Absorption Chiller": "Absorption Chiller",
    "Ancillary Service": "Ancillary Service",
    "CHP 1": "CHP 1",
    "CHP 2": "CHP 2",
    "Compressed Air": "Compressed Air",
    "Compressed Air High T": "Compressed Air High T",
    "Compressed Air Low T": "Compressed Air Low T",
    "Cooling Demand -10°C": "Cooling Demand -10°C",
    "Cooling Generation -10°C": "Cooling Generation -10°C",
    "Emergency Cooling Compressed Air": "Emergency Cooling Compressed Air",
    "Emergency Cooling Low T": "Emergency Cooling Compressed Air",
    "Heat Demand": "Heat Demand",
    "Storage Fill Level": "Storage Fill Level",
    "Power Demand": "Power Demand",
    "Power Price DE": "Power Price DE",
    "Gas Cost": "Gas Cost",
    "Total Energy Costs": "Total Energy Costs",
    "Value Added Through Optimization": "Value Added Through Optimization",
    "Emergency Cooling CHP": "Emergency Cooling CHP",
    "available": "Available",
    "unavailable": "Unavailable",
    "limited": "Limited",
    "unutilized": "Unutilized",
    "AVAILABLE": "Available",
    "UNAVAILABLE": "Unavailable",
    "LIMITED": "Limited",
    "UNUTILIZED": "Unutilized",
    "lastUpdate": "Last Update",
    "status": {
        "error": "Error",
        "success": "Success"
    }
}
